import { ParsedUrlQuery } from 'querystring';

export function getRadius(query: ParsedUrlQuery) {
    if (query['radius']) {
        return query['radius'];
    }

    return '';
}
